import { Card } from '@/components/ui/card';

const AppLayout = ({ children }) => {
  return (
    <Card className="max-w-[600px] mx-auto bg-transparent overflow-hidden">
      {children}
    </Card>
  );
};

export default AppLayout;
